// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { ConditionPart_abstract } from './../abstract/SagaActionLib/ConditionPart_abstract';
export class ConditionPart extends ConditionPart_abstract {}
